import { render, staticRenderFns } from "./organization-finding-card.vue?vue&type=template&id=6b9aa3b1&scoped=true&"
import script from "./organization-finding-card.vue?vue&type=script&lang=js&"
export * from "./organization-finding-card.vue?vue&type=script&lang=js&"
import style0 from "./organization-finding-card.vue?vue&type=style&index=0&id=6b9aa3b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9aa3b1",
  null
  
)

export default component.exports